import { Routes as LandForSaleRoutes } from "traffic-property-app/pages/explore/land-for-sale";
import component from "./land-for-sale";

const [route] = LandForSaleRoutes;
export const Routes = [{ ...route, component }];
